import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['toggler', 'togglee'];

  initialize() {
    this.show = this.show.bind(this);
    this.hide = this.hide.bind(this);
    this.toggle = this.toggle.bind(this);
    this.togglees = this.togglees.bind(this);
  }

  connect() {
    this.togglerTargets.forEach((toggler) => {
      toggler.addEventListener('click', () => this.toggle(toggler));
      toggler.addEventListener('change', () => this.toggle(toggler));

      if (toggler.type === 'radio') {
        document.getElementsByName(toggler.name).forEach((radio) => {
          radio.addEventListener('change', () => this.toggle(toggler));
        });
      }

      if (toggler.checked) {
        this.show(toggler);
      }
    });
  }

  disconnect() {
    this.togglerTargets.forEach((toggler) => {
      toggler.removeEventListener('click', () => this.toggle(toggler));
      toggler.removeEventListener('change', () => this.toggle(toggler));

      if (toggler.type === 'radio') {
        document.getElementsByName(toggler.name).forEach((radio) => {
          radio.removeEventListener('change', () => this.toggle(toggler));
        });
      }
    });
  }

  togglees(toggler) {
    return Array.from(this.toggleeTargets.filter((togglee) => {
      const isMatch = togglee.dataset.toggleGroup === toggler.dataset.toggleGroup;
      return isMatch;
    }));
  }

  toggle(toggler) {
    const toggleesVisible = this.togglees(toggler).some((togglee) => !togglee.classList.contains('hidden'));

    if (toggler.checked && !toggleesVisible) {
      this.show(toggler);
    } else if (!toggler.checked && toggleesVisible) {
      this.hide(toggler);
    }
  }

  show(toggler) {
    this.togglees(toggler).forEach((togglee) => togglee.classList.remove('hidden'));
  }

  hide(toggler) {
    this.togglees(toggler).forEach((togglee) => togglee.classList.add('hidden'));
  }
}
